var React = require('react');

function Bolanaranja (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".ab8f6047-2830-47d9-aaf7-bb19f82a4383{fill:#ff6f5e;opacity:0.5;isolation:isolate;}")),React.createElement("title",{"key":1},"bolanaranja"),React.createElement("g",{"id":"e3fa57d0-0c21-420a-9383-741a850a0a80","data-name":"Capa 2","key":2},React.createElement("g",{"id":"a9019c7a-1514-4bff-baff-7465264dfb38","data-name":"Capa 2"},React.createElement("path",{"className":"ab8f6047-2830-47d9-aaf7-bb19f82a4383","d":"M1.1,285.24c-16.54,160.27,155.1,39.43,366.82,111,128.93,43.56,464.7,348.3,478.2,69.05C861.76,141.78,707.64,26.47,503.72,5.42,148-31.31,17.65,125,1.1,285.24Z"})))]);
}

Bolanaranja.defaultProps = {"viewBox":"0 0 847.21 581.76"};

module.exports = Bolanaranja;

Bolanaranja.default = Bolanaranja;
